import styled, { css } from 'styled-components';

export const ScrollContainer = styled.div<{
  $scrollAuto: boolean;
  $fill?: boolean;
}>`
  padding-left: ${({ theme }) => theme.spacing(0.5)};
  /* background: yellow; */

  ${({ $fill }) =>
    $fill &&
    css`
      display: flex;
      flex-direction: column;
      flex: 1;
    `};

  ${({ $scrollAuto }) =>
    $scrollAuto &&
    css`
      height: 100%;
      overflow: auto;
    `};
`;

export const InteractionsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
`;
